import React, { useState, useCallback } from 'react';
import axios from '../axios';

const EditNotificationSetting = (props) => {
  const [usersAdditionalInformation, setUsersAdditionalInformation] = useState(
    props.users_additional_information
  );

  const endpoint = `/api/users_additional_information/update/${usersAdditionalInformation.id}`;

  const onUpdateIsSendMyParticipateNoticeToFriends = useCallback(
    (e) => {
      const isChecked = e.target.checked;
      const newUsersAdditionalInformation = {
        ...usersAdditionalInformation,
        is_send_my_participate_notice_to_friends: isChecked,
      };
      setUsersAdditionalInformation(newUsersAdditionalInformation);
      axios.post(endpoint, newUsersAdditionalInformation);
    },
    [usersAdditionalInformation]
  );

  const onUpdateIsReceiveFriendsParticipateNotice = useCallback(
    (e) => {
      const isChecked = e.target.checked;
      const newUsersAdditionalInformation = {
        ...usersAdditionalInformation,
        is_receive_friends_participate_notice: isChecked,
      };
      setUsersAdditionalInformation(newUsersAdditionalInformation);
      axios.post(endpoint, newUsersAdditionalInformation);
    },
    [usersAdditionalInformation]
  );

  const onUpdateIsReceiveWatchedEventsNotice = useCallback(
    (e) => {
      const isChecked = e.target.checked;
      const newUsersAdditionalInformation = {
        ...usersAdditionalInformation,
        is_receive_watched_events_notice: isChecked,
      };
      setUsersAdditionalInformation(newUsersAdditionalInformation);
      axios.post(endpoint, newUsersAdditionalInformation);
    },
    [usersAdditionalInformation]
  );

  const onUpdateIsReceiveNewTalkroomNotice = useCallback(
    (e) => {
      const isChecked = e.target.checked;
      const newUsersAdditionalInformation = {
        ...usersAdditionalInformation,
        is_receive_new_talkroom_notice: isChecked,
      };
      setUsersAdditionalInformation(newUsersAdditionalInformation);
      axios.post(endpoint, newUsersAdditionalInformation);
    },
    [usersAdditionalInformation]
  );

  return (
    <div className="container-for-circles-menu container col-lg-8 text-fz-14px text-fw-bold text-black-50">
      <div className="block block-rounded my-0 mx-0">
        <div className="pt-0 block-content pl-2 pr-2 pb-0 py-0">
          <div className="container col-lg-8 py-0">
            <div className="pl-0 pb-1 pt-3 d-flex justify-content-between align-items-center">
              <div>
                <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50 mb-0">
                  自分が参加するイベントを友だちに通知
                </p>
                <p className="pt-2 form-label text-fz-12px text-fw-bold text-black-50">
                  (VIPメンバーのみ設定可能)
                </p>
              </div>
              <div className="toggle_switch d-flex">
                <input
                  id="is_send_my_participate_notice_to_friends"
                  type="checkbox"
                  className="mr-3"
                  defaultChecked={
                    usersAdditionalInformation.is_send_my_participate_notice_to_friends
                  }
                  value={
                    usersAdditionalInformation.is_send_my_participate_notice_to_friends
                  }
                  onChange={onUpdateIsSendMyParticipateNoticeToFriends}
                  disabled={!usersAdditionalInformation.user.is_vip}
                />
                <label
                  htmlFor="is_send_my_participate_notice_to_friends"
                  className="mb-0 toggle_label"
                ></label>
              </div>
            </div>
            <div className="pl-0 pb-1 pt-3 d-flex justify-content-between align-items-center">
              <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">
                友だちが参加するイベントを通知
              </p>
              <div className="toggle_switch d-flex">
                <input
                  id="is_receive_friends_participate_notice"
                  type="checkbox"
                  className="mr-3"
                  defaultChecked={
                    usersAdditionalInformation.is_receive_friends_participate_notice
                  }
                  value={
                    usersAdditionalInformation.is_receive_friends_participate_notice
                  }
                  onChange={onUpdateIsReceiveFriendsParticipateNotice}
                />
                <label
                  htmlFor="is_receive_friends_participate_notice"
                  className="mb-0 toggle_label"
                ></label>
              </div>
            </div>
            <div className="pl-0 pb-1 pt-3 d-flex justify-content-between align-items-center">
              <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">
                自分が見たイベントの開催情報を通知
              </p>
              <div className="toggle_switch d-flex">
                <input
                  id="is_receive_watched_events_notice"
                  type="checkbox"
                  className="mr-3"
                  checked={
                    usersAdditionalInformation.is_receive_watched_events_notice
                  }
                  value={
                    usersAdditionalInformation.is_receive_watched_events_notice
                  }
                  onChange={onUpdateIsReceiveWatchedEventsNotice}
                />
                <label
                  htmlFor="is_receive_watched_events_notice"
                  className="mb-0 toggle_label"
                ></label>
              </div>
            </div>
            <div className="pl-0 pb-1 pt-3 d-flex justify-content-between align-items-center">
              <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">
                トークルームが新しくできたときに通知
              </p>
              <div className="toggle_switch d-flex">
                <input
                  id="is_receive_new_talkroom_notice"
                  type="checkbox"
                  className="mr-3"
                  checked={
                    usersAdditionalInformation.is_receive_new_talkroom_notice
                  }
                  value={
                    usersAdditionalInformation.is_receive_new_talkroom_notice
                  }
                  onChange={onUpdateIsReceiveNewTalkroomNotice}
                />
                <label
                  htmlFor="is_receive_new_talkroom_notice"
                  className="mb-0 toggle_label"
                ></label>
              </div>
            </div>
            <div className="pl-0 pb-1 pt-3 d-flex justify-content-between align-items-center">
              <p className="pt-2 form-label text-fz-12px text-fw-bold text-black-50">
                ※今近い人検索をONにしている場合は、通知をOFFにしていても通知が届きます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditNotificationSetting;
